<template>
  <div class="h-auto min-h-[85vh]">
    <section
      class="block md:hidden fixed inset-x-0 bottom-0 z-50 bg-white shadow-lg"
    >
      <div class="grid grid-cols-2 gap-3 p-4">
        <div class="col-span-1 flex flex-col">
          <p class="font-solusi text-base text-[#212121] font-semibold">
            Total
          </p>
          <div class="flex items-center">
            <p class="font-solusi text-base font-semibold mr-2 text-[#009DFF]">
              Rp. {{ detailTransaction?.price_formatted }}
            </p>
            <svg
              @click="showDetailPayment = true"
              class="w-4 h-4"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.99997 4.80082L2.2958 8.7631C2.01904 9.05888 1.54782 9.08071 1.24363 8.81159C0.939448 8.54247 0.917001 8.08426 1.19376 7.78847L5.44898 3.23698C5.74485 2.92101 6.25516 2.92101 6.55102 3.23698L10.8062 7.78847C11.083 8.08426 11.0606 8.54247 10.7564 8.81159C10.4522 9.0807 9.98096 9.05888 9.7042 8.7631L5.99997 4.80082Z"
                fill="#212121"
              />
            </svg>
          </div>
        </div>
        <button
          v-if="!isExpired || detailTransaction?.proof"
          @click="openUploadProof()"
          class="col-span-1 font-solusi text-base py-2 w-full font-semibold rounded-full border outline-none focus:outline-none text-white bg-[#00446F] border-[#00446F] flex items-center justify-center h-fit-content self-center"
        >
          <svg
            v-if="detailTransaction?.proof"
            class="mr-2"
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="8.5" r="8" fill="#2FA742" />
            <path
              d="M6.18374 12.4412C6.36688 12.629 6.62169 12.7355 6.888 12.7355C6.89059 12.7355 6.8933 12.7355 6.89614 12.7355C7.16555 12.7332 7.42178 12.6225 7.6035 12.4295L12.9241 6.77858C13.2848 6.39547 13.2568 5.80134 12.8619 5.45154C12.4668 5.102 11.8541 5.12893 11.4934 5.51191L6.87599 10.4158L5.43867 8.93984C5.07111 8.56261 4.4579 8.54583 4.06915 8.90189C3.68015 9.25807 3.66284 9.85246 4.03002 10.2297L6.18374 12.4412Z"
              fill="white"
            />
          </svg>
          {{
            detailTransaction?.proof
              ? 'Lihat Bukti Bayar'
              : 'Unggah Bukti Bayar'
          }}
        </button>
      </div>
    </section>
    <div class="my-5 max-w-6xl mx-auto ">
      <div class="flex items-start px-3 md:px-6">
        <router-link
          to="/"
          class="font-solusi text-[#2097F6] hover:font-semibold flex items-center text-xs"
        >
          Beranda
          <svg
            class="mx-2 w-2.5 h-2.5"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.19918 5.99997L3.2369 2.2958C2.94112 2.01904 2.91929 1.54782 3.18841 1.24363C3.45753 0.939448 3.91574 0.917001 4.21153 1.19376L8.76302 5.44898C9.07899 5.74485 9.07899 6.25516 8.76302 6.55102L4.21153 10.8062C3.91574 11.083 3.45753 11.0606 3.18841 10.7564C2.9193 10.4522 2.94112 9.98096 3.2369 9.7042L7.19918 5.99997Z"
              fill="#2097F7"
            />
          </svg>
        </router-link>
        <router-link
          to="/my-classes?page=transaction"
          class="font-solusi text-[#2097F6] hover:font-semibold flex items-center text-xs"
        >
          Daftar Transaksi
          <svg
            class="mx-2 w-2.5 h-2.5"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.19918 5.99997L3.2369 2.2958C2.94112 2.01904 2.91929 1.54782 3.18841 1.24363C3.45753 0.939448 3.91574 0.917001 4.21153 1.19376L8.76302 5.44898C9.07899 5.74485 9.07899 6.25516 8.76302 6.55102L4.21153 10.8062C3.91574 11.083 3.45753 11.0606 3.18841 10.7564C2.9193 10.4522 2.94112 9.98096 3.2369 9.7042L7.19918 5.99997Z"
              fill="#2097F7"
            />
          </svg>
        </router-link>
        <div class="font-solusi flex items-center text-[#212121] text-xs">
          {{ code }}
        </div>
      </div>
    </div>
    <div class="mb-3 max-w-6xl px-3 md:px-6 mx-auto flex">
      <p class="font-desain text-2xl font-semibold text-[#212121]">
        Konfirmasi Pembayaran
      </p>
    </div>
    <div
      class="max-w-6xl px-3 md:px-6 mx-auto w-full flex flex-col md:flex-row"
    >
      <div class="w-full md:w-[60%] order-2 md:order-1">
        <div class="w-full pr-0 md:pr-6 mb-4">
          <div
            class="bg-white rounded-md shadow flex flex-col divide-y-2 divide-gray-200 justify-between mb-4"
          >
            <div class="flex items-center justify-between p-3">
              <p class="font-solusi text-base text-[#212121] font-semibold">
                {{
                  selectedPayment.code == 'mandiritf' ||
                  selectedPayment.code == 'bcatf'
                    ? 'Transfer Bank'
                    : 'E-Wallet'
                }}
              </p>
              <div class="flex flex-col">
                <div class="flex items-center">
                  <img :src="selectedPayment?.images" class="h-5" alt="" />
                  <span class="font-solusi text-base text-[#212121] ml-3">{{
                    selectedPayment?.name
                  }}</span>
                </div>
                <p
                  v-if="
                    selectedPayment.code != 'mandiritf' &&
                      selectedPayment.code != 'bcatf'
                  "
                  class="font-solusi text-sm text-right text-[#212121]"
                >
                  {{ selectedPayment?.receiver }}
                </p>
              </div>
            </div>
            <div class="flex flex-col p-3">
              <div
                v-if="
                  selectedPayment.code == 'mandiritf' ||
                    selectedPayment.code == 'bcatf'
                "
                class="flex flex-col mb-10"
              >
                <p class="font-solusi text-base text-[#333333] mb-3">
                  Nomor Rekening
                </p>
                <div class="flex items-center">
                  <span
                    class="font-desain text-3xl font-semibold text-[#212121] "
                    >{{ selectedPayment?.account }}</span
                  >
                  <input
                    type="hidden"
                    ref="rekening"
                    :value="selectedPayment?.account"
                  />
                  <button
                    @click="copyRekening()"
                    class="ml-4 font-solusi text-[#0A72ED] text-base font-semibold outline-none focus:outline-none flex items-center"
                  >
                    Salin
                    <svg
                      class="ml-1 w-4 h-4"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4 4H3C2.44813 4 2 4.44813 2 5V14C2 14.5519 2.44813 15 3 15H11C11.5519 15 12 14.5519 12 14V13H4V4Z"
                        fill="#0A72ED"
                      />
                      <path d="M11 1V5H15L11 1Z" fill="#0A72ED" />
                      <path
                        d="M10 6V1H6C5.44813 1 5 1.44813 5 2V12H14C14.5519 12 15 11.5519 15 11V6H10Z"
                        fill="#0A72ED"
                      />
                    </svg>
                  </button>
                </div>
                <p class="font-solusi text-base text-[#757575]">
                  {{ selectedPayment?.receiver }}
                </p>
              </div>
              <div class="flex flex-col mb-3">
                <p class="font-solusi text-base text-[#333333] mb-3">
                  Total Pembayaran
                </p>
                <div class="flex items-center">
                  <span
                    class="font-desain text-[#00446F] font-semibold text-3xl"
                  >
                    Rp. {{ firstTotal }}
                  </span>
                  <span
                    class="font-desain text-[#FB8500] font-semibold text-3xl"
                  >
                    {{ endTotal }}
                  </span>
                  <input
                    type="hidden"
                    ref="total"
                    :value="detailTransaction?.price"
                  />
                  <button
                    @click="copyTotal()"
                    class="ml-4 font-solusi text-[#0A72ED] text-base font-semibold outline-none focus:outline-none flex items-center"
                  >
                    <svg
                      class="ml-1 w-5 h-5"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4 4H3C2.44813 4 2 4.44813 2 5V14C2 14.5519 2.44813 15 3 15H11C11.5519 15 12 14.5519 12 14V13H4V4Z"
                        fill="#0A72ED"
                      />
                      <path d="M11 1V5H15L11 1Z" fill="#0A72ED" />
                      <path
                        d="M10 6V1H6C5.44813 1 5 1.44813 5 2V12H14C14.5519 12 15 11.5519 15 11V6H10Z"
                        fill="#0A72ED"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <div class="bg-[#F5F7FD] rounded-lg p-3 relative">
                <div class="w-7 overflow-hidden absolute -top-4 left-[7rem]">
                  <div
                    class=" h-4 w-4 bg-[#F5F7FD] rotate-45 transform origin-bottom-left"
                  ></div>
                </div>
                <p
                  class="font-solusi  text-xl text-[#212121] font-semibold mb-1"
                >
                  PENTING!
                </p>
                <p class="font-solusi text-base text-[#212121] pl-1">
                  Transfer sesuai nominal yang dicantumkan. Pastikan
                  <span
                    class="font-solusi text-base text-[#212121] font-semibold"
                    >3 digit terakhir
                  </span>
                  sama.
                </p>
              </div>
            </div>
          </div>

          <div
            v-if="!isExpired || detailTransaction?.proof"
            class="bg-white rounded-md shadow hidden md:flex flex-col divide-y-2 divide-gray-200 justify-between mb-4"
          >
            <div class="flex items-center p-3">
              <p class="font-solusi text-base text-[#212121] font-semibold">
                Bukti Bayar
              </p>
            </div>
            <div class="px-3 pt-3 pb-5 flex flex-col">
              <p class="font-solusi text-base text-[#333333] mb-6">
                Unggah bukti pembayaran di sini jika kamu telah menyelesaikan
                pembayaran
              </p>
              <button
                @click="openUploadProof()"
                class="font-solusi text-base py-2 px-12 font-semibold rounded-full border outline-none focus:outline-none text-white bg-[#00446F] border-[#00446F] mx-auto"
              >
                {{
                  detailTransaction?.proof
                    ? 'Lihat Bukti Bayar'
                    : 'Unggah Bukti Bayar'
                }}
              </button>
              <!-- <p
                v-if="alert"
                class="text-center font-solusi font-semibold text-[#DE1306] uppercase"
              >
                Belum dibikin sabar! :D
              </p> -->
              <div
                v-if="detailTransaction?.proof"
                class="my-2 flex items-center justify-center"
              >
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8.5" r="8" fill="#2FA742" />
                  <path
                    d="M6.18374 12.4412C6.36688 12.629 6.62169 12.7355 6.888 12.7355C6.89059 12.7355 6.8933 12.7355 6.89614 12.7355C7.16555 12.7332 7.42178 12.6225 7.6035 12.4295L12.9241 6.77858C13.2848 6.39547 13.2568 5.80134 12.8619 5.45154C12.4668 5.102 11.8541 5.12893 11.4934 5.51191L6.87599 10.4158L5.43867 8.93984C5.07111 8.56261 4.4579 8.54583 4.06915 8.90189C3.68015 9.25807 3.66284 9.85246 4.03002 10.2297L6.18374 12.4412Z"
                    fill="white"
                  />
                </svg>
                <p
                  class="font-solusi text-sm text-[#2FBD71] font-semibold ml-2"
                >
                  Berhasil unggah bukti bayar
                </p>
              </div>
            </div>
          </div>

          <div
            class="bg-white rounded-md shadow flex flex-col divide-y-2 divide-gray-200 justify-between mb-4"
          >
            <div class="flex items-center p-3">
              <p class="font-solusi text-base text-[#212121] font-semibold">
                Cara Bayar
              </p>
            </div>
            <div class="px-3 pt-3 pb-5 flex flex-col">
              <ol class=" list-decimal list-outside pl-5 space-y-1.5">
                <li
                  v-for="(step, i) in steps"
                  :key="i"
                  class="font-solusi text-[#383838] pl-2"
                >
                  <img v-if="isImages(step)" :src="step" class="w-64" alt="" />
                  <span v-else class="font-solusi text-[#383838]">
                    {{ step }}
                  </span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w-full md:w-[40%] bg-white md:rounded-md static md:sticky top-20 self-start shadow order-1 md:order-2 mb-4"
      >
        <div class="flex flex-col items-center justify-center p-6">
          <p class="font-desain text-[#212121] text-xl font-semibold mb-3">
            Status Pembayaran
          </p>
          <p
            v-if="
              detailTransaction?.status == 0 && detailTransaction?.proof == ''
            "
            class="font-desain text-[#FB8500] text-4xl font-semibold mb-3"
          >
            {{ countDown }}
          </p>
          <p
            v-else-if="
              detailTransaction?.status == 0 && detailTransaction?.proof != ''
            "
            class="font-desain text-[#219EBC] text-3xl font-semibold mb-3"
          >
            Menunggu Konfirmasi
          </p>
          <p
            v-else-if="detailTransaction?.status == 1"
            class="font-desain text-[#2FBD71] text-3xl font-semibold mb-3"
          >
            Lunas
          </p>
          <p
            v-else
            class="font-desain text-[#DE1306] text-3xl font-semibold mb-3"
          >
            Dibatalkan
          </p>

          <p
            v-if="detailTransaction?.status == 0"
            class="font-solusi text-[#212121] text-base mb-2"
          >
            Batas akhir pembayaran
          </p>
          <p
            v-if="detailTransaction?.status == 0"
            class="font-desain text-[#212121] text-lg font-semibold"
          >
            {{ dateFormatted(detailTransaction?.expired_at) }} WIB
          </p>
        </div>
        <div class="w-full border-t-4 border-[#F5F6F8]"></div>
        <div class="flex flex-col px-4 pt-4">
          <div class="flex flex-row justify-between mb-4 md:mb-2">
            <span class="font-solusi text-sm text-[#212121] font-semibold"
              >Nomor Transaksi</span
            >
            <span class="font-solusi text-sm text-[#212121] font-semibold">{{
              code
            }}</span>
          </div>
        </div>
        <div class="flex flex-col px-4 pb-4">
          <div class="flex flex-row justify-between mb-4 md:mb-2">
            <span class="font-solusi text-sm text-[#212121] font-semibold"
              >Tanggal Pembelian</span
            >
            <span class="font-solusi text-sm text-[#212121] font-semibold">{{
              dateFormatted(detailTransaction?.created_at)
            }}</span>
          </div>
        </div>
        <div class="hidden md:flex flex-col px-4 pb-4 ">
          <div
            v-for="item in detailTransaction.items"
            :key="item.code"
            class="grid grid-cols-12 mb-2"
          >
            <span class="col-span-9 font-solusi text-sm text-[#757575]">
              {{ item.name }}
            </span>
            <span
              class="col-span-3 font-solusi text-sm text-[#212121] text-right"
            >
              Rp. {{ item.price_formatted }}
            </span>
          </div>
          <div class="border-t border-gray-300 border-dashed"></div>
          <div class="flex flex-row justify-between my-2">
            <span class="font-solusi text-sm text-[#212121] font-semibold">
              Sub Total
            </span>
            <span class="font-solusi text-sm text-[#212121] font-semibold">
              {{ moneyFormat(getSubTotal) }}
            </span>
          </div>
          <div
            v-if="detailTransaction?.coupon?.code"
            class="flex flex-row justify-between mb-2"
          >
            <span
              v-if="detailTransaction?.coupon?.percentage != '0'"
              class="font-solusi text-sm text-success font-semibold"
            >
              Potongan ({{ detailTransaction?.coupon?.code }})
              {{ detailTransaction?.coupon?.percentage }}%
            </span>
            <span v-else class="font-solusi text-sm text-success font-semibold">
              Potongan ({{ detailTransaction?.coupon?.code }})
            </span>
            <span
              v-if="detailTransaction?.coupon?.percentage != '0'"
              class="font-solusi text-sm text-success font-semibold"
            >
              ({{
                moneyFormat(getSubTotal - detailTransaction?.coupon?.total)
              }})
            </span>
            <span v-else class="font-solusi text-sm text-success font-semibold">
              ({{
                moneyFormat(getSubTotal - detailTransaction?.coupon?.total)
              }})
            </span>
          </div>
          <div class="flex flex-row justify-between mb-2">
            <span class="font-solusi text-sm text-[#FB8500] font-semibold">
              Kode Unik
            </span>
            <span class="font-solusi text-sm text-[#FB8500] font-semibold">
              {{
                moneyFormat(
                  detailTransaction?.price - detailTransaction?.real_price
                )
              }}
            </span>
          </div>
          <div class="border-t border-gray-200 w-full"></div>
          <div class="flex flex-row justify-between mt-2 mb-5">
            <span class="font-solusi text-lg font-black text-[#212121]"
              >Total</span
            >
            <span class="font-solusi text-lg font-black text-[#212121]"
              >Rp. {{ detailTransaction?.price_formatted }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- Popup Detail Payment -->
    <transition name="fade">
      <div
        v-if="showDetailPayment"
        class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated zoomIn"
      leave-active-class="animated zoomOut"
    >
      <div
        v-if="showDetailPayment"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex z-51"
      >
        <div class="relative w-full md:w-1/3 my-auto md:my-6 mx-2 md:mx-auto">
          <div
            v-click-away="closeDetailPayment"
            class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none divide-y divide-gray-200 max-h-[65vh]"
          >
            <div class="flex items-center justify-between px-5 py-3 rounded-t">
              <p class="font-desain text-lg text-[#212121] font-semibold">
                Ringkasan Pembelian
              </p>
              <div
                class="modal-close cursor-pointer hover:bg-gray-200 rounded-sm p-1 duration-500"
                @click="showDetailPayment = false"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.6451 4.36708C19.1718 3.89382 18.4073 3.89382 17.934 4.36708L12 10.289L6.06598 4.35495C5.59272 3.88168 4.82821 3.88168 4.35495 4.35495C3.88168 4.82821 3.88168 5.59272 4.35495 6.06598L10.289 12L4.35495 17.934C3.88168 18.4073 3.88168 19.1718 4.35495 19.6451C4.82821 20.1183 5.59272 20.1183 6.06598 19.6451L12 13.711L17.934 19.6451C18.4073 20.1183 19.1718 20.1183 19.6451 19.6451C20.1183 19.1718 20.1183 18.4073 19.6451 17.934L13.711 12L19.6451 6.06598C20.1062 5.60485 20.1062 4.82821 19.6451 4.36708Z"
                    fill="#212121"
                  />
                </svg>
              </div>
            </div>
            <div class="overflow-y-auto scroll-custom px-6 py-4">
              <div
                v-for="item in detailTransaction.items"
                :key="item.code"
                class="grid grid-cols-12 mb-2"
              >
                <span class="col-span-9 font-solusi text-sm text-[#757575]">
                  {{ item.name }}
                </span>
                <span
                  class="col-span-3 font-solusi text-sm text-[#212121] text-right"
                >
                  Rp. {{ item.price_formatted }}
                </span>
              </div>
              <div class="border-t border-gray-300 border-dashed"></div>
              <div class="flex flex-row justify-between my-2">
                <span class="font-solusi text-sm text-[#212121] font-semibold">
                  Sub Total
                </span>
                <span class="font-solusi text-sm text-[#212121] font-semibold">
                  {{ moneyFormat(getSubTotal) }}
                </span>
              </div>
              <div
                v-if="detailTransaction?.coupon?.code"
                class="flex flex-row justify-between mb-2"
              >
                <span
                  v-if="detailTransaction?.coupon?.percentage != '0'"
                  class="font-solusi text-sm text-success font-semibold"
                >
                  Potongan ({{ detailTransaction?.coupon?.code }})
                  {{ detailTransaction?.coupon?.percentage }}%
                </span>
                <span
                  v-else
                  class="font-solusi text-sm text-success font-semibold"
                >
                  Potongan ({{ detailTransaction?.coupon?.code }})
                </span>
                <span
                  v-if="detailTransaction?.coupon?.percentage != '0'"
                  class="font-solusi text-sm text-success font-semibold"
                >
                  ({{
                    moneyFormat(getSubTotal - detailTransaction?.coupon?.total)
                  }})
                </span>
                <span
                  v-else
                  class="font-solusi text-sm text-success font-semibold"
                >
                  ({{
                    moneyFormat(getSubTotal - detailTransaction?.coupon?.total)
                  }})
                </span>
              </div>
              <div class="flex flex-row justify-between mb-2">
                <span class="font-solusi text-sm text-[#FB8500] font-semibold">
                  Kode Unik
                </span>
                <span class="font-solusi text-sm text-[#FB8500] font-semibold">
                  {{
                    moneyFormat(
                      detailTransaction?.price - detailTransaction?.real_price
                    )
                  }}
                </span>
              </div>
              <div class="border-t border-gray-200 w-full"></div>
              <div class="flex flex-row justify-between mt-2 mb-5">
                <span class="font-solusi font-black text text-[#212121]"
                  >Total</span
                >
                <span class="font-solusi text-lg font-black text-[#009DFF]"
                  >Rp. {{ detailTransaction?.price_formatted }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Popup Upload Proof -->
    <transition name="fade">
      <div
        v-if="showUploadProof"
        class="opacity-50 fixed inset-0 z-50 bg-black w-full h-full"
      ></div>
    </transition>
    <transition
      enter-active-class="animated zoomIn"
      leave-active-class="animated zoomOut"
    >
      <div
        v-if="showUploadProof"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none justify-center items-center flex z-51"
      >
        <div class="relative w-full md:w-1/3 my-auto md:my-6 mx-2 md:mx-auto">
          <div
            v-click-away="closeUploadProof"
            class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none divide-y divide-gray-200 max-h-[80vh]"
          >
            <div class="flex items-center justify-between p-3 rounded-t">
              <p class="font-desain text-xl text-[#212121] font-semibold">
                {{
                  isAlreadyUpload ? 'Lihat Bukti Bayar' : 'Unggah Bukti Bayar'
                }}
              </p>
              <div
                class="modal-close cursor-pointer hover:bg-gray-200 rounded-sm p-1 duration-500"
                @click="showUploadProof = false"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.6451 4.36708C19.1718 3.89382 18.4073 3.89382 17.934 4.36708L12 10.289L6.06598 4.35495C5.59272 3.88168 4.82821 3.88168 4.35495 4.35495C3.88168 4.82821 3.88168 5.59272 4.35495 6.06598L10.289 12L4.35495 17.934C3.88168 18.4073 3.88168 19.1718 4.35495 19.6451C4.82821 20.1183 5.59272 20.1183 6.06598 19.6451L12 13.711L17.934 19.6451C18.4073 20.1183 19.1718 20.1183 19.6451 19.6451C20.1183 19.1718 20.1183 18.4073 19.6451 17.934L13.711 12L19.6451 6.06598C20.1062 5.60485 20.1062 4.82821 19.6451 4.36708Z"
                    fill="#212121"
                  />
                </svg>
              </div>
            </div>
            <div class="overflow-y-auto scroll-custom px-6 py-4">
              <div class="w-full mb-3">
                <label for="" class="font-solusi text-[#333333] text-sm">
                  File Bukti Pembayaran
                </label>
                <div class="mt-1">
                  <label
                    class="w-full flex flex-col items-center px-4 rounded-md shadow-xm tracking-wide border-2 border-dashed border-[#E5E7EB]"
                    :class="[
                      proofPreview ? 'py-4' : 'py-6',
                      isAlreadyUpload
                        ? ''
                        : 'hover:bg-[#F5F5F5] hover:border-[#0A72ED] hover:text-[#0A72ED]  cursor-pointer duration-300',
                    ]"
                  >
                    <img
                      v-if="proofPreview"
                      :src="proofPreview"
                      alt="Bukti Pembayaran"
                      class="w-full"
                    />
                    <svg
                      v-else
                      class="w-10 h-10"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                          d="M13.3594 3.46083C11.7291 3.46083 10.1549 4.13209 8.9981 5.30957C8.87904 5.29457 8.75904 5.28332 8.63623 5.28332C6.75184 5.28332 5.05207 6.28271 4.12039 7.91396C4.05383 7.90834 3.98445 7.90459 3.9132 7.90459C1.75601 7.90459 0 9.65959 0 11.8178C0 14.0247 1.82813 15.9607 3.9132 15.9607H7.02576C7.27702 18.4835 9.4117 20.4607 12.0002 20.4607C14.5888 20.4607 16.7234 18.4835 16.9747 15.9607H20.0873C22.1713 15.9607 24.0005 14.0247 24.0005 11.8178C24.0005 9.6606 22.2455 7.90459 20.0873 7.90459C19.8173 7.90459 19.5435 7.93646 19.2698 7.9974C18.5582 5.33676 16.1553 3.45996 13.3598 3.45996L13.3594 3.46083ZM13.3594 4.46115C15.8549 4.46115 17.9765 6.25083 18.4042 8.71635C18.4295 8.8626 18.5195 8.99103 18.6479 9.06416C18.7764 9.13822 18.932 9.15135 19.0717 9.09885C19.4148 8.97041 19.7561 8.90478 20.0861 8.90478C21.692 8.90478 22.9989 10.2117 22.9989 11.8177C22.9989 13.492 21.6377 14.9612 20.0861 14.9612H16.9735C16.7213 12.4383 14.5876 10.4612 11.999 10.4612C9.41047 10.4612 7.27581 12.4384 7.02453 14.9612H3.91197C2.36042 14.9612 0.999091 13.4921 0.999091 11.8177C0.999091 10.2117 2.30596 8.90478 3.91197 8.90478C4.03947 8.90478 4.16229 8.92447 4.32729 8.94885C4.54385 8.98447 4.75478 8.86916 4.84948 8.67323C5.56574 7.19949 7.01604 6.28355 8.63596 6.28355C8.75034 6.28355 8.86096 6.30042 8.97064 6.31542L9.12814 6.33605C9.2894 6.35667 9.4497 6.2948 9.55753 6.17386C10.5531 5.06948 11.9022 4.46105 13.3582 4.46105L13.3594 4.46115ZM12 11.4615C14.205 11.4615 16.0003 13.2559 16.0003 15.4618C16.0003 17.6677 14.2059 19.4621 12 19.4621C9.79406 19.4621 7.99968 17.6677 7.99968 15.4618C7.99968 13.2568 9.79406 11.4615 12 11.4615ZM12 12.9615C11.8725 12.9615 11.7441 13.0102 11.6465 13.1077L10.1465 14.6077C9.95155 14.8027 9.95155 15.1196 10.1465 15.3146C10.3415 15.5096 10.6584 15.5096 10.8534 15.3146L11.4994 14.6677V17.4606C11.4994 17.7372 11.7234 17.9603 11.999 17.9603C12.2747 17.9603 12.4987 17.7362 12.4987 17.4606V14.6677L13.1447 15.3146C13.2422 15.4121 13.3706 15.4608 13.4981 15.4608C13.6256 15.4608 13.754 15.4121 13.8515 15.3146C14.0465 15.1196 14.0465 14.8027 13.8515 14.6077L12.3515 13.1077C12.254 13.0102 12.1256 12.9615 11.9981 12.9615H12Z"
                          fill="currentColor"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span
                      v-if="!isAlreadyUpload"
                      class="font-solusi text-sm leading-normal"
                      >{{
                        formProof.file ? formProof.file.name : 'Unggah'
                      }}</span
                    >
                    <span
                      v-if="formProof.file"
                      class="mt-3 text-xs font-semibold font-solusi rounded-full border px-2 py-1 text-blue-600 border-blue-600"
                      >Ubah File</span
                    >
                    <input
                      ref="file"
                      type="file"
                      class="hidden"
                      @change="onFileChange"
                      :disabled="isAlreadyUpload"
                      accept="image/x-png,image/jpeg,image/jpg"
                    />
                  </label>
                </div>
                <p
                  v-if="fileError"
                  class="font-solusi text-xs font-semibold text-[#DE1306] mt-1"
                >
                  Berkas file tidak diperbolehkan!
                </p>
              </div>

              <div class="w-full mb-3">
                <label for="" class="font-solusi text-[#333333] md:text-sm">
                  Nama Pengirim
                </label>
                <input
                  type="text"
                  v-model="formProof.name"
                  :disabled="isAlreadyUpload"
                  placeholder="Nama Pengirim"
                  class="w-full font-solusi md:text-sm text-[#212121] p-2 outline-none focus:outline-none border border-[E5E7EB] rounded focus:border-[#0A72ED] focus:ring disabled:text-[#9E9E9E] disabled:bg-gray-100"
                />
              </div>

              <div class="w-full mb-3">
                <label for="" class="font-solusi text-[#333333] md:text-sm">
                  Nominal
                </label>
                <InputNumber
                  v-model="formProof.nominal"
                  class="w-full"
                  :class="isAlreadyUpload ? '' : ''"
                  :disabled="isAlreadyUpload"
                  mode="currency"
                  currency="IDR"
                  locale="id-ID"
                  thousandSeparator="."
                  :minFractionDigits="0"
                />
              </div>

              <div class="w-full mb-3">
                <label for="" class="font-solusi text-[#333333] md:text-sm">
                  Dikirim Pada Tanggal
                </label>
                <v-date-picker
                  v-model="formProof.date"
                  :masks="{
                    input: ['DD MMMM YYYY'],
                    data: ['DD/MM/YYYY'],
                  }"
                  :min-date="new Date(detailTransaction.created_at)"
                  :max-date="new Date()"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <div class="relative flex items-center">
                      <input
                        class="pl-2 pr-4 py-2 border rounded focus:outline-none focus:border-[#0A72ED] focus:ring w-full bg-transparent z-20 font-solusi text-[#212121] md:text-sm disabled:text-[#9E9E9E] disabled:bg-gray-100"
                        placeholder="DD MMMM YYYY"
                        :value="inputValue"
                        v-on="inputEvents"
                        :disabled="isAlreadyUpload"
                      />
                      <div class="absolute top-0 right-0 p-2 z-10">
                        <svg
                          class="w-5 h-5"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M13.0957 2.05517H11.3972C11.3972 1.82997 11.3077 1.614 11.1485 1.45476C10.9892 1.29552 10.7732 1.20605 10.548 1.20605C10.3228 1.20605 10.1069 1.29552 9.94762 1.45476C9.78838 1.614 9.69892 1.82997 9.69892 2.05517H6.30208C6.30208 1.82997 6.21262 1.614 6.05338 1.45476C5.89414 1.29552 5.67816 1.20605 5.45296 1.20605C5.22776 1.20605 5.01179 1.29552 4.85255 1.45476C4.69331 1.614 4.60384 1.82997 4.60384 2.05517H2.90528C2.45483 2.05522 2.02285 2.23421 1.70436 2.55276C1.38588 2.87131 1.20699 3.30333 1.20703 3.75378V13.0949C1.20703 13.3179 1.25096 13.5387 1.33631 13.7448C1.42165 13.9508 1.54675 14.138 1.70445 14.2957C1.86215 14.4533 2.04937 14.5784 2.25541 14.6637C2.46145 14.749 2.68228 14.7929 2.90528 14.7928H13.0957C13.3187 14.7929 13.5395 14.7491 13.7456 14.6638C13.9516 14.5785 14.1389 14.4534 14.2966 14.2957C14.4543 14.1381 14.5794 13.9509 14.6647 13.7448C14.7501 13.5388 14.794 13.3179 14.7939 13.0949V3.75378C14.794 3.53073 14.7501 3.30985 14.6648 3.10376C14.5795 2.89768 14.4544 2.71042 14.2967 2.55268C14.139 2.39494 13.9517 2.26982 13.7457 2.18446C13.5396 2.0991 13.3187 2.05516 13.0957 2.05517ZM13.0957 13.0949H2.90528V7.15093H13.0957V13.0949ZM13.0957 5.45165H2.90528V3.75378H4.60382C4.60382 3.97898 4.69328 4.19496 4.85253 4.3542C5.01177 4.51344 5.22774 4.6029 5.45294 4.6029C5.67814 4.6029 5.89412 4.51344 6.05336 4.3542C6.2126 4.19496 6.30206 3.97898 6.30206 3.75378H9.69888C9.69888 3.97898 9.78834 4.19496 9.94758 4.3542C10.1068 4.51344 10.3228 4.6029 10.548 4.6029C10.7732 4.6029 10.9892 4.51344 11.1484 4.3542C11.3077 4.19496 11.3971 3.97898 11.3971 3.75378H13.0956L13.0957 5.45165Z"
                            fill="#333333"
                          />
                        </svg>
                      </div>
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </div>
            <div
              v-if="detailTransaction.proof == ''"
              class="flex justify-center p-4"
            >
              <button
                @click="submitUploadProof()"
                class="font-solusi text-base py-2 px-14 rounded-full font-semibold flex items-center"
                :class="
                  checkFormProof && !loadingUpload
                    ? 'text-[#FFFFFF] bg-[#00446F]'
                    : 'text-[#9E9E9E] bg-[#F5F6F8] cursor-not-allowed'
                "
              >
                <svg
                  v-if="loadingUpload"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="spinner"
                  class="w-4 h-4 animate-spin mr-2"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                  ></path>
                </svg>
                Kirim Bukti Bayar
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TransactionModel from '@/models/TransactionModel'
import { Payment } from '@/dto'
import moment from 'moment'
import { moneyFormat } from '@/utils/Util'
import { useToast } from 'vue-toastification'

export default defineComponent({
  name: 'Konfirmasi Pembayaran',
  setup() {
    const toast = useToast()
    return {
      toast,
    }
  },
  data() {
    return {
      alert: false,
      code: this.$route.params.code,
      detailTransaction: {} as any,
      steps: [] as any,
      TransactionDate: '',
      selectedPayment: {} as any,
      paymentId: 0,
      uploadDate: '',
      countDown: '',
      showDetailPayment: false,
      showUploadProof: false,
      firstTotal: '' as string,
      endTotal: '' as string,
      formProof: {
        file: null,
        name: '' as string,
        date: '' as string,
        nominal: 0 as number,
      },
      proofPreview: '' as string,
      fileError: false,
      loadingUpload: false,
      isAlreadyUpload: false,
      isExpired: false,
      paymentImages: [
        {
          code: 'ovo',
          images: '/assets/images/payment/logo_ovo.png',
        },
        {
          code: 'dana',
          images: '/assets/images/payment/logo_dana.png',
        },
        {
          code: 'gopay',
          images: '/assets/images/payment/logo_gopay.png',
        },
        {
          code: 'link-aja',
          images: '/assets/images/payment/logo_linkaja.png',
        },
        {
          code: 'shopeepay',
          images: '/assets/images/payment/logo_shopeepay.png',
        },
        {
          code: 'bcatf',
          images: '/assets/images/payment/logo_bca.png',
        },
        {
          code: 'mandiritf',
          images: '/assets/images/payment/logo_mandiri.png',
        },
        {
          code: 'paylater',
          images: '/assets/images/payment/logo_paylater.png',
        },
      ],
    }
  },
  created() {
    this.getDetailTransaction()
  },
  computed: {
    _seconds() {
      return 1000
    },
    _minutes() {
      return 1000 * 60
    },
    _hours() {
      return 60000 * 60
    },
    _days() {
      return 3600000 * 24
    },
    getSubTotal(): number {
      let subTotal = 0
      if (this.detailTransaction?.items) {
        this.detailTransaction.items.forEach((el: any) => {
          subTotal = subTotal + el.price
        })
        return subTotal
      } else {
        return 0
      }
    },
    checkFormProof(): boolean {
      if (
        this.formProof.file &&
        this.formProof.name &&
        this.formProof.date &&
        this.formProof.nominal
      ) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    async getPayment(paymentId: number) {
      const { data } = await TransactionModel.listPayment()
      const find: any = data.find((el: Payment) => el.id == paymentId)
      this.selectedPayment = find
      const payment: any = this.paymentImages.find(
        (el: any) => el.code == this.selectedPayment.code
      )
      this.selectedPayment.images = payment.images
      let steps = this.selectedPayment.instructions
      steps = steps.replace('(tekan lama pada gambar)', '')
      steps = steps.replace('$1', this.selectedPayment.account)
      steps = steps.replace(
        '$2',
        'Rp ' + this.detailTransaction.price_formatted
      )
      steps = steps.replace('$3', this.selectedPayment.receiver)
      this.steps = steps.split(/\\n/)
      this.steps.forEach((el: any, i: number) => {
        this.steps[i] = el.substring(3)
      })
    },
    async getDetailTransaction() {
      const { data, success } = await TransactionModel.listOneTransaction(
        this.code
      )
      if (success) {
        this.detailTransaction = data
        this.endTotal = this.detailTransaction.price_formatted.substr(-3)
        this.firstTotal = this.detailTransaction.price_formatted.substr(
          0,
          this.detailTransaction.price_formatted.length - 3
        )

        this.showCountdown()
        this.TransactionDate = moment(this.detailTransaction.created_at).format(
          'DD MMM YYYY'
        )
        this.uploadDate = moment(this.detailTransaction.expired_at)
          .locale('id')
          .format('DD MMMM YYYY')

        this.getPayment(data.payment_method.id)
      } else {
        this.$router.push('/')
      }
    },

    showCountdown() {
      const timer = setInterval(() => {
        const now = new Date()
        const end = new Date(this.detailTransaction.expired_at)
        const distance = end.getTime() - now.getTime()
        if (distance < 0) {
          this.isExpired = true
          clearInterval(timer)
          this.countDown = 'Melebihi Batas Waktu'
          return
        }
        // const days = Math.floor(distance / this._days)
        const hours = Math.floor(distance / this._hours)
        const minutes = Math.floor((distance % this._hours) / this._minutes)
        const seconds = Math.floor((distance % this._minutes) / this._seconds)
        const displayMinutes = minutes < 10 ? `0` + minutes : minutes
        const displaySeconds = seconds < 10 ? `0` + seconds : seconds
        const displayHours = hours < 10 ? `0` + hours : hours
        // const displayDays = days < 10 ? 0 + days : days
        this.countDown =
          displayHours + ':' + displayMinutes + ':' + displaySeconds
      }, 1000)
    },

    dateFormatted(date: string) {
      return moment(date)
        .locale('id')
        .format('dddd, DD MMMM YYYY HH:mm')
    },

    moneyFormat(price: number) {
      return moneyFormat(price)
    },

    closeDetailPayment() {
      this.showDetailPayment = false
    },

    openUploadProof() {
      this.showUploadProof = true
      if (this.detailTransaction?.proof) {
        this.isAlreadyUpload = true
        this.formProof.name = this.detailTransaction?.sender
        this.formProof.date = moment(this.detailTransaction.send_at).format(
          'DD MMMM YYYY'
        )
        this.formProof.nominal = this.detailTransaction?.nominal_sent
        this.proofPreview = 'https://' + this.detailTransaction.proof
      } else {
        this.formProof.nominal = this.detailTransaction?.price
        this.isAlreadyUpload = false
      }
    },

    closeUploadProof() {
      this.showUploadProof = false
      this.formProof.name = ''
      this.formProof.date = ''
      this.formProof.file = null
      this.proofPreview = ''
      this.fileError = false
    },

    copyRekening() {
      const rekening = this.$refs.rekening as HTMLInputElement
      try {
        rekening.setAttribute('type', 'text')
        rekening.select()
        document.execCommand('copy')
        this.toast.success('Berhasil disalin')
      } catch (err) {
        this.toast.error('Oops, unable to copy')
      }
      rekening.setAttribute('type', 'hidden')
    },

    copyTotal() {
      const total = this.$refs.total as HTMLInputElement
      try {
        total.setAttribute('type', 'text')
        total.select()
        document.execCommand('copy')
        this.toast.success('Berhasil disalin')
      } catch (err) {
        this.toast.error('Oops, unable to copy')
      }
      total.setAttribute('type', 'hidden')
    },

    isImages(step: any) {
      return step.match(/https?:\/\//)
    },

    onFileChange(event: any) {
      const file = event.target.files[0]
      const fileName = file.name.substr(-3).toLowerCase()
      this.fileError = false
      if (['png', 'jpg', 'peg'].indexOf(fileName) <= -1) {
        this.formProof.file = null
        this.proofPreview = ''
        const file = this.$refs.file as HTMLInputElement
        file.value = ''
        this.fileError = true
        return
      }
      this.formProof.file = event.target.files[0]
      this.proofPreview = URL.createObjectURL(file)
    },

    async submitUploadProof() {
      if (
        this.formProof.name &&
        this.formProof.date &&
        this.formProof.file &&
        this.formProof.nominal
      ) {
        const payload = {
          name: this.formProof.name,
          nominal: this.formProof.nominal,
          file: this.formProof.file,
          date: moment(this.formProof.date).format('YYYY-MM-DD'),
        }
        this.loadingUpload = true
        await TransactionModel.sendPaymentConfirmation(
          this.detailTransaction?.id,
          payload
        )
          .then(async res => {
            if (res.success) {
              await this.getDetailTransaction()
              this.loadingUpload = false
              this.closeUploadProof()
              this.toast.success('Berhasil mengirim bukti bayar')
            } else {
              this.loadingUpload = false
              this.toast.error('Gagal mengirim bukti, silahkan coba kembali')
            }
          })
          .catch(err => {
            this.toast.error('Gagal mengirim bukti, silahkan coba kembali')
            this.loadingUpload = false
            console.log(err)
          })
      } else {
        return
      }
    },
    isNumber(event: any) {
      console.log(event)
      const charCode = event.which ? event.which : event.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        event.preventDefault()
      } else {
        return true
      }
    },
  },
})
</script>

<style scoped>
::v-deep(.p-inputtext) {
  font-family: 'SolusiSans';
}
::v-deep(.p-inputnumber-input) {
  font-size: 0.875rem;
  line-height: 1.25rem;
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-text-opacity: 1;
  color: rgba(33, 33, 33, var(--tw-text-opacity));
  border-radius: 0.25rem;
  border: rgba(229, 231, 235, var(--tw-border-opacity)) solid 1px;
}
@media (max-width: 768px) {
  ::v-deep(.p-inputnumber-input) {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
::v-deep(.p-inputnumber-input:focus) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
    var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
    calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000);
}
::v-deep(.p-inputnumber-input:hover) {
  border-color: rgba(229, 231, 235);
}
::v-deep(.p-inputnumber-input:disabled) {
  color: rgba(158, 158, 158);
  background-color: rgba(243, 244, 246);
}
</style>
